<template>
  <transition name="plus-icon">
    <div class="modelBox" v-if="recruit.modelShow">
      <div class="model">
        <div class="head">
          <p class="title">{{ info.title }}</p>
          <p class="tip">{{ info.tip }}</p>
        </div>
        <div class="content">
          <div class="part">
            <h3>职责描述：</h3>
            <p v-for="(item, index) in info.duty" :key="index">
              {{ index + 1 }}、{{ item }}
            </p>
          </div>
          <div class="part">
            <h3>任职要求：</h3>
            <p v-for="(item, index) in info.requirement" :key="index">
              {{ index + 1 }}、{{ item }}
            </p>
          </div>
          <div class="part" v-if="info.about">
            <h3>实习相关</h3>
            <p v-for="(item, index) in info.about" :key="index">
              {{ index + 1 }}、 {{ item }}
            </p>
          </div>
          <div class="part" v-if="info.tel">
            <h3>简历投递</h3>
            <p>{{ info.tel }}</p>
          </div>
        </div>
        <div class="btn hvr-shutter-out-horizontal" @click="closeModal">
          <p>关闭</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ recruit: "recruit", info: "recruitInfo" })
  },
  methods: {
    ...mapMutations(["changeRModel"]),
    closeModal() {
      this.changeRModel(false);
    }
  }
};
</script>

<style lang="less" scoped>
.plus-icon-enter-active {
  transition: opacity 0.5s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0.5s;
}
.plus-icon-leave-to {
  opacity: 0;
}
.plus-icon-enter-to {
  opacity: 1;
}
.hvr-shutter-out-horizontal:before {
  background: rgba(255, 125, 51, 1);
}

.modelBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
  .model {
    position: fixed;
    width: 5.88rem;
    height: 6.55rem;
    background: rgba(255, 255, 255, 1);
    background-image: url("../images/niao.png");
    background-position: 0% 80%;
    background-size: 3.62rem 2.69rem;
    background-repeat: no-repeat;
    border-radius: 0.15rem;
    top: 50%;
    left: 50%;
    margin-left: -2.94rem;
    margin-top: -3.475rem;
    .head {
      width: 3.6rem;
      height: 0.91rem;
      border-radius: 0.5rem;
      background: rgba(255, 125, 51, 1);
      // background: url("../images/btn.png");
      // background-size: 100% 100%;
      position: absolute;
      top: -0.45rem;
      left: 50%;
      margin-left: -1.8rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        font-weight: bold;
      }
      p {
        font-size: 0.2rem;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
    .content {
      width: 5.3rem;
      margin: 0.6rem auto 0;
      height: 4.4rem;
      overflow: auto;
      h3 {
        font-size: 0.28rem;
        font-weight: bold;
        margin-top: 0.2rem;
        margin-bottom: 0.1rem;
      }
      p {
        font-size: 0.26rem;
        color: rgba(51, 51, 51, 1);
        line-height: 0.4rem;
      }
    }
    .btn {
      width: 4.65rem;
      height: 0.91rem;
      transform: scale(0.7);
      background: rgba(255, 125, 51, 1);
      border-radius: 0.46rem;
      position: absolute;
      bottom: 0.35rem;
      left: 50%;
      margin-left: -2.325rem;
      p {
        font-size: 0.4rem;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 0.91rem;
      }
    }
  }
}
//滚动条样式
::-webkit-scrollbar {
  width: 10px;
}
/* 垂直滚动条的滑动块 */
::-webkit-scrollbar-thumb:vertical {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 125, 51, 0.5);
  background-color: rgba(255, 125, 51, 0.5);
}

::-webkit-scrollbar-track {
  box-shadow: 0px 0px 3px #dfdfdf inset;
  border-radius: 10px;
  background: #eee;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(255, 125, 51, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/recruitModal.vue